module.exports = __webpack_public_path__ + "static/img/news-demo2.c957ac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/news/news-demo2.png
// module id = dA+c
// module chunks = 134